import { GET, POST } from './api'

function normalizeTrainingApprovalResponse(result) {
  if (!result) {
    return { ok: false, status: 0, data: null }
  }
  return {
    ok: !result?.error,
    status: result?.error?.status || result?.status || (result?.error ? 400 : 200),
    data: result,
  }
}

function buildPendingQuery({ page = 1, pageSize = 10, search = '', status = 'pending' } = {}) {
  const query = new URLSearchParams({ page: String(page), pageSize: String(pageSize) })
  query.set('status', status)
  if (String(search || '').trim()) query.set('search', String(search).trim())
  return query.toString()
}

export const ReadPendingTrainingApprovals = async params => normalizeTrainingApprovalResponse(
  await GET(`/course-certificate-approvals/pending?${buildPendingQuery(params)}`, true)
)

export const ReadTrainingApprovals = async params => normalizeTrainingApprovalResponse(
  await GET(`/course-certificate-approvals/my-approvals?${buildPendingQuery(params)}`, true)
)

export const ReadTrainingApproval = async id => normalizeTrainingApprovalResponse(
  await GET(`/course-certificate-approvals/${encodeURIComponent(id)}`, true)
)

export const ApproveTrainingCertificate = async id => normalizeTrainingApprovalResponse(
  await POST(`/course-certificate-approvals/${encodeURIComponent(id)}/approve`, {}, true)
)

export const RejectTrainingCertificate = async (id, reason = '') => normalizeTrainingApprovalResponse(
  await POST(`/course-certificate-approvals/${encodeURIComponent(id)}/reject`, { data: { reason } }, true)
)

export { buildPendingQuery, normalizeTrainingApprovalResponse }
